/* eslint-disable max-statements */
/* eslint-disable no-mixed-spaces-and-tabs */
import { useEffect, useRef, useState } from 'react';
import React from 'react';

import { useMantineTheme } from '@mantine/core';
import { Dropzone, IMAGE_MIME_TYPE, MIME_TYPES } from '@mantine/dropzone';
import validator from 'validator';
import './css/addImageModal.css';
import { stateNotificationsEnum } from '../../Utils/notification';
import { useMutation, useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import {
	setSelectedSection,
	setTab
} from '../../../redux/actions/sideBarAction';
import { useNavigate } from 'react-router-dom';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import { SetNotificationAction } from '../../../redux/actions/notificationAction';
import { globalEnv } from '../../../config/baseConfig';
import { hideSearchbarAction } from '../../../redux/actions/searchBarAction';
import Scrollbars from 'react-custom-scrollbars-2';
import {
	BasicTopicStyle,
	TopicStyles
} from '../../SubSections/Topic/TopicStyling/StyleComponents/mixins/mixins';
import {
	dropzoneChildren,
	FileType,
	uploadFilesAndGetLocation,
	IFile,
	IUploadFile,
	readImages,
	readVideos,
	uploadStateValues
} from '../../Utils/upload/uploadImagesUtils';
import { SetUnsavedChangesAction } from '../../../redux/actions/globalAction';
import SaveButton from '../../Utils/saveButton';
import { useDebouncedCallback } from 'use-debounce';
import { Tag } from '../../Utils/Components/tag';
import { axiosInstance } from '../../../config/axiosInstance';
import { checkTopicName, verifTitle } from '../../SubSections/Topic/helpers';
import { ClockTypes } from '../../SubSections/Topic/TopicStyling/StyleComponents/mixins/optionsValues';
import axios from 'axios';

export default function AddTopic() {
	const cancelButtonRef = useRef(null);

	const theme = useMantineTheme();
	const [mediaFiles, setMediaFiles] = useState<IFile[]>([]);
	const [uploadFiles, setUploadFiles] = useState<IUploadFile[]>([]);

	const [title, setTitle] = useState('');
	const [titleErrorMsg, setTitleErrorMsg] = useState({
		message: '',
		error: false
	});

	const [description, setDescription] = useState('');
	const [style, setStyle] = useState<TopicStyles>(BasicTopicStyle);
	const [tags, setTags] = useState<string[]>([]);
	const [isChanged, setIsChanged] = useState(false);
	const [isPhone, setIsPhone] = useState<boolean>(false);

	const dispatch = useDispatch();
	dispatch(setSelectedSection('Create Topic'));
	dispatch(setTab('add-topic'));
	dispatch(hideSearchbarAction());

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	async function fetchSettingsData() {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data } = await axios.get(
			`${globalEnv.BASE_URL}/settings/topic-style`,
			config
		);
		return data;
	}

	const { data, isError } = useQuery([], () => fetchSettingsData(), {
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		staleTime: 5000
	});

	useEffect(() => {
		if (data != null) {
			let clock;
			try {
				if (data.clock.kind === ClockTypes.Analog)
					clock = {
						kind: data.clock.kind,
						showSeconds: data.clock.showSeconds,
						size: data.clock.size,
						isDark: data.clock.isDark,
						isNumbered: data.clock.isNumbered
					};
				else if (data.clock.kind === ClockTypes.Digital)
					clock = {
						kind: data.clock.kind,
						showSeconds: data.clock.showSeconds,
						size: data.clock.size,
						boldness: data.clock.boldness,
						showAmPm: data.clock.showAmPm,
						showTwentyFour: data.clock.showTwentyFour
					};
				else
					clock = {
						kind: data.clock.kind,
						size: data.clock.size,
						boldness: data.clock.boldness
					};
			} catch (e) {
				clock = BasicTopicStyle.clock;
			}

			try {
				let defaultBookmarkList;
				if (data.defaultBookmarkList != null)
					defaultBookmarkList = data.defaultBookmarkList;
				else defaultBookmarkList = BasicTopicStyle.defaultBookmarkList;

				setStyle({
					appearanceStyle: {
						font: data.appearanceStyle.font,
						mode: data.appearanceStyle.mode,
						opacity: data.appearanceStyle.opacity,
						view: data.appearanceStyle.view
					},
					quoteStyle: {
						size: data.quoteStyle.size,
						useCustomQuote: data.quoteStyle.useCustomQuote,
						customQuote:
							data.quoteStyle.customQuote != null
								? data.quoteStyle.customQuote
								: null
					},
					sidebarStyle: {
						contentWidth: data.sidebarStyle.contentWidth,
						width: data.sidebarStyle.width,
						view: data.sidebarStyle.view
					},
					wallpaperStyle: {
						background: data.wallpaperStyle.background,
						blur: data.wallpaperStyle.blur,
						brightness: data.wallpaperStyle.brightness
					},
					searchbarOptions: data.searchbarOptions,
					searchEngines: data.searchEngines,
					focusStyle:
						data.focusStyle != null
							? {
									myFocus: data.focusStyle.myFocus,
									size: data.focusStyle.size
							  }
							: BasicTopicStyle.focusStyle,
					greetingStyle:
						data.greetingStyle != null
							? { size: data.greetingStyle.size }
							: BasicTopicStyle.greetingStyle,
					clock: clock,
					featuresStyle: {
						time: data.featuresStyle.time,
						date: data.featuresStyle.date,
						weather: data.featuresStyle.weather,
						bookmarks: data.featuresStyle.bookmarks,
						notes: data.featuresStyle.notes,
						quote: data.featuresStyle.quote,
						integrations: data.featuresStyle.integrations,
						searchBar: data.featuresStyle.searchBar
					},
					integrationsStyle: data.integrationsStyle,
					bookmarkStyle: {
						selectedBookmarks: data.bookmarkStyle.selectedBookmarks,
						blackAndWhite: data.bookmarkStyle.blackAndWhite,
						openNewTab: data.bookmarkStyle.openNewTab,
						square: data.bookmarkStyle.square,
						gap: data.bookmarkStyle.gap,
						size: data.bookmarkStyle.size
					},
					defaultBookmarkList: defaultBookmarkList
				});
			} catch (e) {
				console.log(e);
			}
		}
	}, [data]);

	const upload = async () => {
		const uploadedFiles = await uploadFilesAndGetLocation(
			mediaFiles,
			setMediaFiles,
			uploadFiles,
			title
		);

		let uploadState = '';

		if (uploadedFiles.length == mediaFiles.length) {
			console.log('change uploadState success');
			uploadState = uploadStateValues.SUCCESS;
		} else if (uploadedFiles.length === 0) {
			uploadState = uploadStateValues.FAILED;
		} else uploadState = uploadStateValues.PARTIAL;

		if (uploadState === uploadStateValues.FAILED)
			throw Error('An error occured.');

		const images = uploadedFiles.filter((file) => file.type === FileType.IMAGE);
		const videos = uploadedFiles.filter((file) => file.type === FileType.VIDEO);

		const dto = {
			name: title,
			description: description,
			backgroundImages: images,
			videos: videos,
			newStyle: style,
			defaultBookmarkList: style.defaultBookmarkList,
			tags: tags,
			isPrivate: true,
			isPhone: isPhone
		};

		const { data: response } = await axiosInstance.post(
			globalEnv.BASE_URL + '/admin/topic/create',
			dto,
			{
				headers: {
					Authorization: 'Bearer ' + ACCESS_TOKEN
				}
			}
		);

		return { response: response, uploadState: uploadState };
	};

	const debounced = useDebouncedCallback((value) => {
		setIsChanged(true);
		checkTopicName({
			topicName: value,
			setTitleErrorMsg: setTitleErrorMsg
		});
	}, 1000);

	useEffect(() => {
		dispatch(
			SetUnsavedChangesAction({
				unsavedChanges: isChanged
			})
		);
	}, [isChanged]);

	useEffect(() => {
		return () => {
			console.log('Unmount!');
		};
	}, []);

	const navigate = useNavigate();

	const { mutate, isLoading } = useMutation(upload, {
		onSuccess: (data) => {
			data.uploadState === uploadStateValues.SUCCESS
				? dispatch(
						SetNotificationAction({
							type: stateNotificationsEnum.SUCCESS,
							message: 'Successfully updated topic info.'
						})
				  )
				: dispatch(
						SetNotificationAction({
							type: stateNotificationsEnum.WARN,
							message: "Couldn't upload all images."
						})
				  );
			if (!isPhone) navigate(`../topic/${data.response._id}/edit-images`);
			else navigate(`../topic/${data.response._id}/phone/edit-images`);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: 'Error occured while creating topic.'
				})
			);
		}
	});

	const uploadImage = () => {
		mutate();
	};

	function addTag() {
		setTags([...tags, '']);
	}

	return (
		<div className="content-container">
			<Scrollbars autoHide>
				<div className="w-full mx-auto bg-white dark:bg-gray-800 transition-all duration-500">
					<form className="mx-auto w-full max-w-3xl pt-10">
						<div className="flex flex-wrap -mx-3 mb-6">
							<div className="w-full px-3">
								<label
									className="block uppercase tracking-wide text-gray-700
																		dark:text-gray-300 text-xs font-bold mb-2"
								>
									Name
								</label>
								<input
									className={`appearance-none block w-full py-3 px-4 rounded-xl font-semibold
																text-gray-700 dark:text-white placeholder-gray-500 dark:placeholder-gray-500
																bg-gray-300 dark:bg-gray-700 border focus:outline-none transition-all duration-500
																 border-gray-300 focus:border-gray-400 dark:focus:border-gray-600 ${
																		titleErrorMsg.error
																			? 'border-red-500'
																			: 'border-gray-200 dark:border-gray-700'
																	}`}
									id="grid-title"
									placeholder="Topic name"
									onBlur={() => {
										verifTitle(title, setTitleErrorMsg);
									}}
									onChange={(e) => {
										setTitleErrorMsg({
											error: false,
											message: ''
										});
										setTitle(e.target.value);
										debounced(e.target.value);
									}}
								/>
								{titleErrorMsg.error ? (
									<p className="text-red-500 text-xs italic">
										{titleErrorMsg.message}
									</p>
								) : (
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Required
									</p>
								)}
							</div>
						</div>

						<div className="flex flex-wrap -mx-3 mb-6">
							<div className="w-full px-3">
								<label className="block uppercase tracking-widetext-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
									Description
								</label>
								<textarea
									className="inputStyle"
									id="grid-photographer"
									placeholder="Topic description"
									onChange={(e) => {
										setDescription(e.target.value);
										setIsChanged(true);
									}}
								/>
								<p className="text-gray-600 dark:text-gray-500 text-xs italic ">
									Optional
								</p>
							</div>
						</div>

						<div className="mx-auto w-full mt-10 z-0">
							<Dropzone
								className="dark:bg-gray-800 z-0 transition-all duration-500"
								onDrop={(files: File[]) => {
									const extractedImages: File[] = [];
									const extractedVideos: File[] = [];

									files.forEach((file) => {
										if (file.type.startsWith('image')) {
											extractedImages.push(file);
										} else if (file.type.startsWith('video')) {
											extractedVideos.push(file);
											console.log(file);
										}
									});

									readImages(
										mediaFiles,
										setMediaFiles,
										uploadFiles,
										setUploadFiles,
										extractedImages,
										20
									);

									readVideos(
										mediaFiles,
										setMediaFiles,
										uploadFiles,
										setUploadFiles,
										extractedVideos,
										20
									);

									setIsChanged(true);
								}}
								onReject={(files) => console.log('rejected files', files)}
								maxSize={100 * 1024 ** 2} // 100 MB
								accept={[MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.mp4]}
							>
								{(status) =>
									dropzoneChildren(
										mediaFiles,
										status,
										theme,
										uploadFiles,
										setUploadFiles,
										setMediaFiles,
										20
									)
								}
							</Dropzone>
						</div>

						{/* Progress bar */}
						{/* <div className="h-1 w-full bg-gray-300">
								<div
									style={{ width: `${progress}%` }}
									className={`h-full ${
										progress < 70 ? 'bg-red-600' : 'bg-green-600'
									}`}
								></div>
							</div> */}

						<div className="mt-5 lg:mt-6 lg:mb-0">
							<h3 className="block uppercase tracking-widetext-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
								Tags
							</h3>
							<div className="flex flex-row space-x-2">
								{tags.map((tag, index) => (
									<Tag
										name={tag}
										isMine={true}
										setIsChanged={setIsChanged}
										index={index}
										setTags={setTags}
										tags={tags}
									/>
								))}

								{tags.length > 0 ? (
									<div
										className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500
													bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
													dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
													dark:text-gray-300 text-gray-600 hover:text-gray-200"
									>
										<span className="text-xs font-bold mx-1" onClick={addTag}>
											➕
										</span>
									</div>
								) : (
									<div className="inline-block">
										<span
											className="text-xs font-bold mx-1 text-gray-400"
											onClick={addTag}
										>
											This topic has no Tags
										</span>

										<div
											className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
										>
											<span className="text-xs font-bold mx-1" onClick={addTag}>
												Create Topic's first Tag➕
											</span>
										</div>
									</div>
								)}
							</div>
						</div>
					</form>
				</div>
				<div className="bg-white dark:bg-gray-800 px-4 pb-3 sm:px-6 flex flex-row-reverse transition-all duration-500">
					{mediaFiles.length > 0 &&
						!validator.isEmpty(title) &&
						!titleErrorMsg.error && (
							<SaveButton isSaving={isLoading} saveFunc={() => uploadImage()} />
						)}
					<button
						type="button"
						className="btn btn-outline btn-sm btn-error mr-2"
						onClick={() => navigate('../documents')}
						ref={cancelButtonRef}
					>
						Cancel
					</button>
				</div>
			</Scrollbars>
		</div>
	);
}
